/**
 * Improved Header – Mega Menu interactions
 * Upload to: assets/improved-header.js
 *
 * Usage from section file:
 *   window.ImprovedHeader.init('{{ section.id }}');
 */
window.ImprovedHeader = window.ImprovedHeader || {};

window.ImprovedHeader.init = function (sectionId) {
  'use strict';

  var sectionEl = document.getElementById('shopify-section-' + sectionId);
  if (!sectionEl) return;

  // Desktop nav rendered by header-nav-desktop snippet
  var navEl = sectionEl.querySelector('.header__menu');
  if (!navEl) return;

  var panels = sectionEl.querySelectorAll('.mega-menu[data-menu-title]');
  if (!panels.length) return;

  panels.forEach(function (panel) {
    var menuTitle    = panel.dataset.menuTitle;
    var openBehavior = panel.dataset.openBehavior || 'hover';

    // Find the top-level <a> whose visible text matches data-menu-title.
    // Scope to `ul > li > a` first to avoid matching a child link with the
    // same label as a top-level entry.
    var trigger = null;
    var topLinks = navEl.querySelectorAll('ul > li > a');
    for (var i = 0; i < topLinks.length; i++) {
      if (topLinks[i].textContent.trim().toLowerCase() === menuTitle.toLowerCase()) {
        trigger = topLinks[i];
        break;
      }
    }
    // Fallback: search all links in the nav
    if (!trigger) {
      var allLinks = navEl.querySelectorAll('a');
      for (var j = 0; j < allLinks.length; j++) {
        if (allLinks[j].textContent.trim() === menuTitle) {
          trigger = allLinks[j];
          break;
        }
      }
    }
    if (!trigger) return;

    // Wire ARIA
    trigger.setAttribute('aria-haspopup', 'true');
    trigger.setAttribute('aria-expanded', 'false');
    trigger.setAttribute('aria-controls', panel.id);

    function openPanel() {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }

    function closePanel() {
      panel.hidden = true;
      trigger.setAttribute('aria-expanded', 'false');
    }

    if (openBehavior === 'hover') {
      // ── Hover / focus behaviour ──────────────────────────────────
      var closeTimer;

      function cancelClose() { clearTimeout(closeTimer); }
      function scheduleClose() { closeTimer = setTimeout(closePanel, 150); }

      // Use the parent <li> so moving from trigger into the panel (which is
      // a sibling child of <header>, not of <li>) does not cause a flicker.
      var triggerItem = trigger.closest('li') || trigger.parentElement;
      triggerItem.addEventListener('mouseenter', function () { cancelClose(); openPanel(); });
      triggerItem.addEventListener('mouseleave', scheduleClose);

      trigger.addEventListener('focus', openPanel);
      trigger.addEventListener('blur', function (e) {
        if (!panel.contains(e.relatedTarget)) scheduleClose();
      });

      panel.addEventListener('mouseenter', cancelClose);
      panel.addEventListener('mouseleave', scheduleClose);
      panel.addEventListener('focusin',  cancelClose);
      panel.addEventListener('focusout', function (e) {
        if (!panel.contains(e.relatedTarget) && !trigger.contains(e.relatedTarget)) {
          scheduleClose();
        }
      });

    } else {
      // ── Click behaviour ──────────────────────────────────────────
      trigger.addEventListener('click', function (e) {
        if (panel.hidden) {
          e.preventDefault();
          openPanel();
        } else {
          closePanel();
          // allow default link navigation when closing
        }
      });

      document.addEventListener('click', function (e) {
        if (!panel.contains(e.target) && !trigger.contains(e.target)) {
          closePanel();
        }
      });
    }

    // ── Keyboard: Escape closes; Arrow Down enters panel ─────────
    panel.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closePanel();
        trigger.focus();
      }
    });

    trigger.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') {
        closePanel();
        return;
      }
      if (e.key === 'ArrowDown' && !panel.hidden) {
        e.preventDefault();
        var firstFocusable = panel.querySelector('a, button, [tabindex]:not([tabindex="-1"])');
        if (firstFocusable) firstFocusable.focus();
      }
    });
  });

  // ── Theme editor: open panel when block is selected ─────────
  document.addEventListener('shopify:block:select', function (e) {
    if (!e.target) return;
    var panel = e.target.closest('.mega-menu');
    if (panel && sectionEl.contains(panel)) {
      panel.hidden = false;
    }
  });

  document.addEventListener('shopify:block:deselect', function (e) {
    if (!e.target) return;
    var panel = e.target.closest('.mega-menu');
    if (panel && sectionEl.contains(panel)) {
      panel.hidden = true;
    }
  });
};
